import React from "react";

const MapSection = () => {
  // We encode the address to make it URL-friendly
  const encodedAddress = encodeURIComponent(
    "Govardhan Energies LLP, Pij, Gujarat 387230",
  );
  const simpleEmbedUrl = `https://maps.google.com/maps?q=${encodedAddress}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  return (
    <section className="w-full mt-[-120px] z-[999] relative">
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full h-[300px] md:h-[400px] lg:h-[600px] rounded-[30px] overflow-hidden">
          <iframe
            // Niche wala URL red marker (pin) ke saath location dikhayega
            src={simpleEmbedUrl}
            title="Utpann Production Location Map"
            className="w-full h-full border-0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};

export default MapSection;
